import React, { useState } from 'react';
import {
	makeStyles,
	Button,
	MenuItem,
	LinearProgress,
	Box,
	TextField,
	InputAdornment,
	Grid,
	Tabs,
	Tab,
	Divider,
	withStyles,
	FormControlLabel,
	Checkbox,
} from '@material-ui/core';
import DayPickerInput from 'react-day-picker/DayPickerInput';
// import 'react-datepicker/dist/react-datepicker.css';
// import 'react-day-picker/lib/style.css';

import '../../../node_modules/react-day-picker/lib/style.css';
import { green } from '@material-ui/core/colors';

// import { TextField } from 'formik-material-ui';
// import TextField from '@material-ui/core/TextField
import { Field, Form, Formik } from 'formik';
import PhoneIcon from '@material-ui/icons/Phone';
import TitleText from '../../components/reusableComponents/TitleText';
import { useMediaQuery, useTheme } from '@material-ui/core';
import AccountCircle from '@material-ui/icons/AccountCircle';
import BodyText from './BodyText';
import EmailIcon from '@material-ui/icons/Email';
import LockIcon from '@material-ui/icons/Lock';
import LocationOnIcon from '@material-ui/icons/LocationOn';
import LocalizationProvider from '@mui/lab/LocalizationProvider';
import AdapterDateFns from '@mui/lab/AdapterDateFns';

import DatePicker from '@mui/lab/DatePicker';
import { useLocation } from 'react-router-dom';
import { useDispatch } from 'react-redux';
import {
	setBaggage,
	setBaggageAdult2,
	setBaggageAdult3,
	setBaggageAdult4,
	setBaggageAdult5,
	setBaggageAdult6,
	setBaggageAdult7,
	setBaggageAdult8,
	setBaggageAdult9,
	setBaggageChild1,
	setBaggageChild2,
	setBaggageChild3,
	setBaggageChild4,
	setBaggageChild5,
	setBaggageChild6,
	setBaggageChild7,
	setBaggageChild8,
	setBaggageChild9,
} from '../../reducers/UiReducer';
// import TextField from '@mui/material/TextField';

const useStyles = makeStyles((theme) => ({
	selectField: {
		'& .MuiOutlinedInput-root': {
			'& fieldset': {
				border: '1px solid #959595',
			},
		},
		backgroundColor: 'white',
		marginBottom: 30,
		width: '100%',
		marginTop: 10,
		borderRadius: 10,
		[theme.breakpoints.down('xs')]: {
			marginBottom: 15,
			marginTop: 8,
		},
	},
	InputPropsStyle: {
		backgroundColor: 'white',
		borderRadius: 5,
	},
	inputPropsStyle: {
		padding: 14,
	},
	createButton: {
		backgroundColor: '#39c9bb',
		color: 'white',
		borderRadius: 25,
		width: '100%',
		padding: '11px 8px',
		'&:hover': {
			backgroundColor: '#39c9bb',
		},
	},
	tabBorder: {
		borderBottom: '2px solid transparent',
		color: '#7B95AB',
		fontWeight: 400,
	},
	tabBorderColor: {
		borderBottom: '2px solid #313131',
		color: '#00325B',
		fontWeight: 700,
	},
	tab: {
		[theme.breakpoints.up('sm')]: {
			'& .MuiTab-root': {
				minWidth: 241,
				fontSize: 22,
			},
		},
	},
	date: {
		'& .MuiOutlinedInput-root': {
			borderRadius: 25,
		},
	},
}));
const GreenCheckbox = withStyles({
	root: {
		color: '#39c9bb',
		'&$checked': {
			color: '#39c9bb',
		},
	},
	checked: {},
})((props) => <Checkbox color='default' {...props} />);
// const bag = ['Extra Baggage-5kg     Rs2000', 'Mrs'];
const bag = [
	{
		data: 'Extra Baggage-5kg Rs2000',
		price: 2000,
	},
	{
		data: 'None',
		price: '',
	},
];
// const visa = [
// 	'Tourist',
// 	'Employment',
// 	'Seamen',
// 	'Residence',
// 	'Student',
// 	'Dependent',
// 	'Migrant',
// ];
const BaggageForm = () => {
	const classes = useStyles();
	// const theme = useTheme();
	const [value3, setValue3] = React.useState(new Date());

	// const handleChange = (event, newValue) => {
	// 	setValue(newValue);
	// };
	const [value, setValue2] = React.useState(null);
	const [startDate, setStartDate] = useState(new Date());
	const location = useLocation();
	const [check, setCheck] = useState(false);
	const handleCheck = (event) => {
		setCheck(event.target.checked);
	};
	const [currentStep, SetCurrentStep] = useState('Step 1');
	const dispatch = useDispatch();
	// const matches = useMediaQuery(theme.breakpoints.down('xs'));
	const handleSubmit = (data) => {
		console.log(data);
	};
	function range(start, end) {
		return Array(end)
			.fill()
			.map((_, idx) => start + idx);
	}
	let ad = range(
		0,
		location.state.body
			? location.state.body.AdultCount
			: location.state.returnBody
			? location.state.returnBody.AdultCount
			: ''
	);
	let chld = range(
		0,
		location.state.body
			? location.state.body.ChildCount
			: location.state.returnBody
			? location.state.returnBody.ChildCount
			: ''
	);
	return (
		<>
			<Formik
				initialValues={{}}
				validate={(values) => {
					const errors = {};
				}}
				onSubmit={handleSubmit}>
				{({ submitForm, isSubmitting }) => (
					<>
						<Form>
							<>
								{ad.length > 0 &&
									ad.map((i, index) => {
										return (
											<>
												<Grid container spacing={2} alignItems='center'>
													<Grid
														item
														xs={6}
														style={{ display: 'flex', alignItems: 'center' }}>
														<Box display='flex'>
															<TitleText two>{index + 1}</TitleText>
															<TitleText two textStyle={{ marginLeft: 5 }}>
																Adult
															</TitleText>
														</Box>
														<Field
															component={TextField}
															select
															name='user'
															type='text'
															label='Select Baggage'
															variant='outlined'
															// onChange={(e, value) =>
															// 	dispatch(
															// 		setBaggage(
															// 			e.target.value ===
															// 				'Extra Baggage-5kg Rs2000'
															// 				? 2000
															// 				: ''
															// 		)
															// 	)
															// }
															style={{ marginTop: 19, marginLeft: 10 }}
															className={classes.selectField}
															InputProps={{
																className: classes.InputPropsStyle,
															}}
															inputProps={{
																style: { padding: 14 },
															}}>
															{bag.map((item, index2) => (
																<MenuItem
																	key={index}
																	value={item.data}
																	onClick={() =>
																		dispatch(
																			index + 1 == 1
																				? setBaggage(item.price)
																				: index + 1 == 2
																				? setBaggageAdult2(item.price)
																				: index + 1 == 3
																				? setBaggageAdult3(item.price)
																				: index + 1 == 4
																				? setBaggageAdult4(item.price)
																				: index + 1 == 5
																				? setBaggageAdult5(item.price)
																				: index + 1 == 6
																				? setBaggageAdult6(item.price)
																				: index + 1 == 7
																				? setBaggageAdult7(item.price)
																				: index + 1 == 8
																				? setBaggageAdult8(item.price)
																				: index + 1 == 9
																				? setBaggageAdult9(item.price)
																				: setBaggage(item.price)
																		)
																	}>
																	{item.data}
																</MenuItem>
															))}
														</Field>
													</Grid>

													{/* <Grid item xs={3} style={{ marginBottom: 12 }}></Grid> */}
												</Grid>
											</>
										);
									})}
								{chld.length > 0 &&
									chld.map((i, index) => {
										return (
											<>
												<Grid container spacing={2} alignItems='center'>
													<Grid
														item
														xs={6}
														style={{ display: 'flex', alignItems: 'center' }}>
														<Box display='flex'>
															<TitleText two>{index + 1}</TitleText>
															<TitleText two textStyle={{ marginLeft: 5 }}>
																Child
															</TitleText>
														</Box>
														<Field
															component={TextField}
															select
															name='user'
															type='text'
															label='Select Baggage'
															variant='outlined'
															// onChange={(e, value) => console.log(value)}
															style={{ marginTop: 19, marginLeft: 10 }}
															className={classes.selectField}
															InputProps={{
																className: classes.InputPropsStyle,
															}}
															inputProps={{
																style: { padding: 14 },
															}}>
															{bag.map((item, index2) => (
																<MenuItem
																	key={index2}
																	value={item.data}
																	onClick={() =>
																		dispatch(
																			index + 1 == 1
																				? setBaggageChild1(item.price)
																				: index + 1 == 2
																				? setBaggageChild2(item.price)
																				: index + 1 == 3
																				? setBaggageChild3(item.price)
																				: index + 1 == 4
																				? setBaggageChild4(item.price)
																				: index + 1 == 5
																				? setBaggageChild5(item.price)
																				: index + 1 == 6
																				? setBaggageChild6(item.price)
																				: index + 1 == 7
																				? setBaggageChild7(item.price)
																				: index + 1 == 8
																				? setBaggageChild8(item.price)
																				: index + 1 == 9
																				? setBaggageChild9(item.price)
																				: setBaggage(item.price)
																		)
																	}>
																	{item.data}
																</MenuItem>
															))}
														</Field>
													</Grid>

													{/* <Grid item xs={3} style={{ marginBottom: 12 }}></Grid> */}
												</Grid>
											</>
										);
									})}
							</>
						</Form>
					</>
				)}
			</Formik>
		</>
	);
};

export default BaggageForm;
